"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var _underscored = require('underscore.string/underscored');
var _titleize = require('underscore.string/titleize');
var _words = require('underscore.string/words');
var _capitalize = require('underscore.string/capitalize');
var superHumanize = function (string) {
    // the standard str.humanize kills _id$
    string = _underscored(string).replace(/_/g, ' ').replace(/\[\]/g, ' ');
    var out = _titleize(_capitalize(string));
    var words = _words(out);
    var subs = {
        Url: 'URL',
        Uri: 'URI',
        Html: 'HTML',
        Id: 'ID',
        id: 'ID',
    };
    lodash_1.each(subs, function (v, k) {
        var index = words.indexOf(k);
        if (index !== -1) {
            words[index] = v;
        }
    });
    return words.join(' ');
};
exports.default = superHumanize;
